module.exports = __webpack_public_path__ + "img/baiwan-1.ccfbba0a.webp";